import { injectReducer } from '../../store/reducers'
import { getListPatient, getListAppointment, openPage, clearList } from './modules/patients'

export default (store) => ({
  path : '',
  onEnter: function() {
      store.dispatch(clearList());
  },
  childRoutes: [
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Patients = require('./containers/PatientsContainer').default
      const reducer = require('./modules/patients').default
      injectReducer(store, { key: 'patients', reducer })
        var doctorId = nextState.params.id;
      // store.dispatch(getListPatient(doctorId));
      // store.dispatch(getListAppointment());
      store.dispatch(openPage(doctorId));
      cb(null, Patients)
    }, 'patients')
  }
})


// WEBPACK FOOTER //
// ./src/routes/PatientDatabaseAdmin/index.js